import React, { useEffect } from 'react';
import { RECHTSLINKS, RECHTSTEXT_TITEL, RechtstextArt } from '../config/rechtslinks';

/**
 * T-163 (v1.8.46): öffentliche Routen /agb, /datenschutz und /impressum leiten auf das jeweilige Ziel weiter
 * (AGB-PDF aus dem System bzw. Seite der Website). Ohne Anmeldung erreichbar.
 */
const Rechtstext: React.FC<{ art: RechtstextArt }> = ({ art }) => {
  const ziel = RECHTSLINKS[art];
  useEffect(() => {
    window.location.replace(ziel);
  }, [ziel]);
  return (
    <div style={{ padding: '3rem 1rem', textAlign: 'center', fontFamily: 'inherit' }}>
      <p>{RECHTSTEXT_TITEL[art]} werden geöffnet ...</p>
      <p><a href={ziel}>Falls sich nichts tut, bitte hier klicken.</a></p>
    </div>
  );
};

export default Rechtstext;
